/* import __COLOCATED_TEMPLATE__ from './data-category-editor.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface Args {
  dataCategoryGroupList: Array<any>;
  dataCategoryFilter: DataCategoryFilter;
  onUpdate: (dataCategoryFilter: $TSFixMe) => void;
}

export type DataCategoryFilter = {
  filter_type: 'AT' | 'BELOW';
  include: boolean;
  data_categories: Record<string, string[]>;
};

export default class DataCategoryEditor extends Component<Args> {
  @tracked selectedDataCategories: { [key: string]: string[] } = {};
  @tracked selectedFilterType = 'AT';
  @tracked selectedInclude = true;
  @tracked tableData: { group: string; category: string }[] = [];

  constructor(owner: any, args: Args) {
    super(owner, args);
    this.selectedDataCategories = this.args.dataCategoryFilter.data_categories;
    this.selectedFilterType = this.args.dataCategoryFilter.filter_type;
    this.selectedInclude = this.args.dataCategoryFilter.include;
    this.updateTableData();
  }

  @action
  addDataCategory(item: any) {
    if (item.group in this.selectedDataCategories) {
      this.selectedDataCategories[item.group].push(item.text);
    } else {
      this.selectedDataCategories[item.group] = [item.text];
    }

    this.updateSelection();
  }

  @action
  changeFilterType(value: string) {
    this.selectedFilterType = value;
    this.updateSelection();
  }

  @action
  changeInclude(value: boolean) {
    this.selectedInclude = value;
    this.selectedFilterType = 'AT';
    this.updateSelection();
  }

  @action
  deleteDataCategory(item: any) {
    this.selectedDataCategories[item.group] = this.selectedDataCategories[item.group].filter(
      (category) => category !== item.category,
    );
    if (this.selectedDataCategories[item.group].length === 0) {
      delete this.selectedDataCategories[item.group];
    }

    this.updateSelection();
  }

  @action
  updateTableData() {
    this.tableData = [];
    Object.keys(this.selectedDataCategories).forEach((group) => {
      this.selectedDataCategories[group].forEach((category) => {
        this.tableData.push({
          group,
          category,
        });
      });
    });
  }

  @action
  updateSelection() {
    this.updateTableData();
    this.args.onUpdate({
      filter_type: this.selectedFilterType,
      include: this.selectedInclude,
      data_categories: this.selectedDataCategories,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::DataCategoryEditor': typeof DataCategoryEditor;
    'standalone/salesforce/setup/article-sync/data-category-editor': typeof DataCategoryEditor;
  }
}
